export default __webpack_public_path__ + "static/media/delete.7d551f71.svg";